// src/utils/auth.js   
import Cookies from 'js-cookie';

export const isLoggedIn = () => {
    const id = Cookies.get('manager_id');
    return id && parseInt(id) > 0;
};

export const getManagerName = () => {
    return Cookies.get('manager') || 'Менеджер';
};

export const logout = () => {
    Cookies.remove('manager_id');
    Cookies.remove('manager');
};
